import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
import { failureHash } from "./organization.static";
class ApiEpOrganizationMembership {
}
/**
 * Used to create new User's Membership in Organization
 */
ApiEpOrganizationMembership.create = ({ organization, role, user, }) => apiRequest({
    body: {
        organization,
        role,
        user,
    },
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/membership/`,
    method: "POST",
}, failureHash);
/**
 * Used to destroy User's Membership in Organization
 */
ApiEpOrganizationMembership.destroy = ({ membership, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/membership/${membership.id}`,
    method: "DELETE",
    headers: membership.organizationId
        ? [["X-Organization-Context", membership.organizationId.toString()]]
        : undefined,
}, failureHash);
/**
 * Used to confirm User Membership invitation to Organization
 */
ApiEpOrganizationMembership.inviteConfirm = ({ code, }) => apiRequest({
    body: {
        code,
    },
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/membership/invite-confirm`,
    method: "POST",
}, failureHash);
/**
 * Used to list Membership
 */
ApiEpOrganizationMembership.list = ({ is_confirmed, organization, user, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/membership/`,
    method: "GET",
    query: {
        is_confirmed,
        organization,
        user,
    },
    headers: organization
        ? [["X-Organization-Context", organization.toString()]]
        : undefined,
}, failureHash);
/**
 * Used to update existing Membership in Organization
 */
ApiEpOrganizationMembership.update = ({ membership, }) => apiRequest({
    body: membership,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/membership/${membership.id}`,
    method: "PUT",
}, failureHash);
export class ApiEpOrganization {
}
/**
 * Used to control Organization Membership
 */
ApiEpOrganization.Membership = ApiEpOrganizationMembership;
/**
 * Used to create new Organization
 */
ApiEpOrganization.create = ({ name, }) => apiRequest({
    body: { name },
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/organization/`,
    method: "POST",
}, failureHash);
/**
 * Used to delete Organization
 */
ApiEpOrganization.destroy = ({ id, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/organization/${id}`,
    method: "DELETE",
}, failureHash);
/**
 * Used to get Organization list
 */
ApiEpOrganization.list = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/organization/`,
    method: "GET",
}, failureHash);
/**
 * Used to get Organization by id
 */
ApiEpOrganization.retrieve = ({ id }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/organization/${id}`,
    method: "GET",
}, failureHash);
/**
 * Used to update Organization
 */
ApiEpOrganization.update = ({ organization, }) => apiRequest({
    body: organization,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/organization/organization/${organization.id}`,
    method: "PUT",
}, failureHash);
//# sourceMappingURL=organization.js.map